import { Link } from "react-router-dom";
import { Wrench, Fan, Wind, Flame, Sun, Droplets, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/common/Reveal";
import { CAPABILITIES } from "@/data/site";

const ICONS = [Wrench, Fan, Wind, Flame, Sun, Droplets];

export const CapabilityTile = ({ c, i, light = false }) => {
  const Icon = ICONS[i % ICONS.length];
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <div className={`group flex h-full flex-col border p-7 transition-colors duration-300 sm:p-8 ${light ? "border-canvas/15 bg-ink hover:border-brand-soft" : "border-canvas-line bg-canvas-800 hover:border-brand"}`} data-testid={`capability-tile-${i}`}>
        <div className="flex items-center justify-between">
          <span className={`label-mono ${light ? "text-canvas/70" : "text-steel"}`}>{c.code}</span>
          <Icon className={`h-6 w-6 ${light ? "text-brand-soft" : "text-brand"}`} strokeWidth={1.5} />
        </div>
        <h3 className="mt-10 font-display text-3xl font-bold uppercase leading-none">{c.title}</h3>
        <p className={`mt-4 flex-1 text-sm leading-relaxed sm:text-base ${light ? "text-canvas/75" : "text-steel"}`}>{c.text}</p>
      </div>
    </Reveal>
  );
};

export const CapabilitiesGrid = () => (
  <section className="relative bg-ink text-canvas cad-grid-light" data-testid="home-capabilities">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead tone="dark" label="Section 02 — Capabilities" title="One mechanical package, from first fix to handover" />
        <Link to="/capabilities" data-testid="home-capabilities-link" className="group inline-flex items-center gap-2 font-display text-lg font-semibold uppercase tracking-[0.08em] text-brand-soft">
          All capabilities <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </Link>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-px md:grid-cols-2 lg:grid-cols-3">
        {CAPABILITIES.map((c, i) => <CapabilityTile key={c.code} c={c} i={i} light />)}
      </div>
    </div>
  </section>
);
